<template>
<div class="chapter">
<div class="inner_page">
<a id="page_i"></a>
<a id="page_ii"></a>
<p class="fm02t"><span class="bold">Praise for <em class="italic">Favorite Son</em></span></p>
<p class="fm021"><span class="bold">“INTENSELY PLOTTED, FAST-MOVING.”</span></p>
<p class="fm022"><em class="italic">—Publishers Weekly</em></p>
<p class="fm021"><span class="bold">“EXCITING, SCANDALOUS.”</span><em class="italic">—Kirkus Reviews</em></p>
<p class="fm021"><span class="bold">“EXTREMELY GOOD READING.”</span></p>
<p class="fm022"><em class="italic">—Washington Post Book World</em></p>
<p class="fm021"><span class="bold">“THE INTRIGUE WHIPS ALONG.”</span></p>
<p class="fm022"><em class="italic">—Los Angeles Times Book Review</em></p>
<p class="fm021"><span class="bold">“OUTSTANDING.”</span><em class="italic">—Cincinnati Post</em></p>
<p class="fm021"><span class="bold">“TOP-NOTCH THRILLER FICTION … IRRESISTIBLE.”</span></p>
<p class="fm022"><em class="italic">—Booklist</em></p>
<a id="page_iii"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Fm02.vue?29107b43